import React, { useState, useEffect } from 'react';
import { db } from '../common/Firestore';
import * as COLLECTION from '../common/constant/collections'
import { collection, getDocs, setDoc, doc, addDoc, deleteDoc, updateDoc } from "firebase/firestore";
import dayjs from 'dayjs';
import { message } from 'antd';

export const useCustomer = () => {
    const [customers, setCustomers] = useState(null);
        var [forceStop, setForceStop] = useState(false);

    useEffect(() => {
        getListCustomers()
    }, [])

    const getListCustomers = async () => {
        let schools = []
        const schoolData = await getDocs(collection(db, COLLECTION.SCHOOL));
        if (schoolData) {
            // console.log("All Screens: ", screensData)
            schoolData.forEach((school) => {
                if (school.exists) {
                    const schoolData = school.data();
                    schools.push({ key: school.id, ...schoolData })
                }
            })
        }
        let sc = []
        const userData = await getDocs(collection(db, COLLECTION.USER));
        if (userData) {
            // console.log("All Screens: ", screensData)
            userData.forEach((user) => {
                if (user.exists) {
                    const userData = user.data();
                    userData.expired = dayjs(userData.expired.seconds * 1000)
                    userData.birthday = dayjs(userData.birthday.seconds * 1000)
                    if (userData.school) {
                        // console.log("School data: ", schools, userData.school)
                        const schoolIndex = schools.findIndex(s => s.id === userData.school)
                        if (schoolIndex != -1) {
                            // console.log("School data: ", schools[schoolIndex])
                            userData.schoolData = { ...schools[schoolIndex] }
                        } else {
                            userData.schoolData = { key: userData.school, id: userData.school }
                        }
                    }
                    sc.push({ key: user.id, ...userData })
                }
            })
        }
        setCustomers(sc)
    }

    const updateCustomer = async (customer) => {
        if (customer) {
            console.log("customer Need To Save: ", customer);
            let vaildBirthday = false;
            let validExpired = false;
            const oBirthday = customer.birthday;
            const oExpired = customer.expired;
            try {
                // if(customer.school) {
                //     customer.school=customer.school.id;
                // }
                const res = await setDoc(doc(db, COLLECTION.USER, customer.userId), customer)
                if (!res) {
                    customer.birthday = dayjs(customer.birthday)
                    vaildBirthday = true;
                    customer.expired = dayjs(customer.expired)
                    validExpired = true;
                    let finalCustomer = (customers && Array.isArray(customers)) ? [...customers] : []
                    let oldConfigIndex = finalCustomer.findIndex(t => t.key === customer.key)
                    if (oldConfigIndex != -1)
                        finalCustomer[oldConfigIndex] = customer;
                    else finalCustomer.push(customer)
                    setCustomers(finalCustomer)
                    return { error: false, data: finalCustomer, message: "Success" }
                } else {
                    console.log("RESPONSE: ", res)
                    return { error: true, data: res, message: `Không thể lưu học sinh do: "${res.message}"` };
                }

            } catch (error) {
                console.error("Cannot save user: ", error)
                let errorMessage = error.message;
                if (!vaildBirthday)
                    errorMessage = `Ngày sinh không đúng định dạng "dd/mm/YYYY"`;
                // errorMessage = `Ngày sinh (${oBirthday}) không đúng định dạng "dd/mm/YYYY"`;
                else if (!validExpired)
                    errorMessage = `Ngày hết hạn không đúng định dạng "dd/mm/YYYY"`
                // errorMessage = `Ngày hết hạn (${oExpired}) không đúng định dạng "dd/mm/YYYY"`
                // errorMessage = `${vaildBirthday ? "" : (errorMessage + " và ")}Ngày hết hạn không hợp lệ`
                // return { error: true, message: `Không thể lưu học sinh do: "${errorMessage}"` }
                return { error: true, message: errorMessage }
            }
        } else return { error: true, message: "Không thể cập nhật với thông tin để trống!" }
    }

    const addNewCustomer = async (newCustomer) => {
        if (newCustomer) {
            try {
                const res = await addDoc(collection(db, COLLECTION.USER), newCustomer)
                if (res) {
                    let finalCustomer = (customers && Array.isArray(customers)) ? [...customers] : []
                    finalCustomer.push(newCustomer)
                    setCustomers(finalCustomer)
                    return finalCustomer
                }

            } catch (error) {
                console.error("Cannot add new User: ", error)
            }
        } else return
    }

    async function asyncPushData(array, callback) {
        for (let index = 0; index < array.length; index++) {
            if (forceStop) {
                index = array.length;
                break;
            }
            else
                await callback(array[index], index, array);
        }
    }
    const deleteCustomers = async (customers) => {
        const response={
            successed:false,
            code:0,
            totalDelete:0,
            needToDelete:customers.length,
            cannotDelete:[],
            message:""
        }
        if (customers && Array.isArray(customers)) {
            var totalDelete=0;
            console.log("DELETE Request: ", customers)
            await asyncPushData(customers, async(customer) => {

                try {
                    const res = await deleteDoc(doc(db, COLLECTION.USER, customer))
                    totalDelete++;
                    console.log("DELETE RESONSE: ", res)

                } catch (error) {
                    console.error("Không thể xoá User: ", error)
                    response.message="Có một số người dùng không xoá được"
                    response.cannotDelete.push(customer)
                    response.code=1;
                }
                
            })
            response.totalDelete=totalDelete
            if(totalDelete==response.needToDelete) {
                response.successed=true
            } else {
                response.successed=false
            }
            await getListCustomers()
        } else {
            response.code=3;
            response.message="Danh sách người dùng phải là một mảng giá trị"
        }

        return response
    }

    const changeStatus = async (customers) => {
        const response={
            successed:false,
            code:0,
            totalEdit:0,
            totalEdit:customers.length,
            totalEdit:[],
            message:""
        }
        if (customers && Array.isArray(customers)) {
            var totalEdit=0;
            console.log("Edit Request: ", customers)
            await asyncPushData(customers, async(customer) => {

                try {
                    const res = await updateDoc(doc(db, COLLECTION.USER, customer.userId), {status:customer.status})
                    totalEdit++;
                    console.log("EDIT RESONSE: ", res)

                } catch (error) {
                    console.error("Không thể chỉnh sửa User: ", error)
                    response.message="Có một số người dùng không thể chỉnh sửa được"
                    response.totalEdit.push(customer)
                    response.code=1;
                }
                
            })
            response.totalEdit=totalEdit
            if(totalEdit==response.totalEdit) {
                response.successed=true
            } else {
                response.successed=false
            }
            await getListCustomers()
        } else {
            response.code=3;
            response.message="Danh sách người dùng phải là một mảng giá trị"
        }

        return response
    }

    return { customers, updateCustomer, addNewCustomer, deleteCustomers, changeStatus };
}